import { ThemeProvider, createTheme, CssBaseline, ThemeOptions } from "@mui/material";

import ProofStatus from "components/ProofStatus";
import Navigation from "Navigation"
import { FavoritesProvider } from "assets/favorites";

export const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#b257f7',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#aa00ff',
    },
    text: {
      primary_bold: 'rgba(0, 0, 0, 0.75)'
    },
    background: {
      default: '#faf9fb',
    },
  },
};

function App() {

  const theme = createTheme(themeOptions);

  return (
    <ThemeProvider theme={theme}>
      <FavoritesProvider>
        <CssBaseline/>
        <Navigation/>
        <ProofStatus/>
      </FavoritesProvider>
    </ThemeProvider>  
  );
}

export default App;
